import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      // 首页
      path: "/index",
      name: "home",
      component: () => import('./views/Home.vue'),
      meta:{title:"首页"}
    },
    {
      // 首页
      path: "/qrcode",
      name: "qrcode",
      component: () => import('./views/qrCode.vue'),
      meta:{title:"小站教育助手"}
    }
  ]
});
